import Stone from "./Stone";

export default Stone;
